import { createSelector } from "reselect";

const selectSetting = (state) => state.setting;

export const getHeaderProfileMenuShow = createSelector([selectSetting], (setting) => setting.headerProfileMenuShow);

export const getHeaderMainMenuShow = createSelector([selectSetting], (setting) => setting.headerMainMenuShow);
